import cx from "classnames";
import { type FC, memo, useCallback } from "react";
import { canv } from "@/canv/global";
import type { MoreStickersTool } from "@/tools/moreTool/MoreStickersTool";
import type { CachedStickerType } from "./stickerCache";
import { stickerCache } from "./stickerCache";
import style from "./stickersWindow.module.css";

type StickersProps = {
    stickers: CachedStickerType[];
    searchQuery: string;
};

export const Stickers: FC<StickersProps> = memo(({ stickers, searchQuery }) => {
    const itemClick = useCallback((path: string) => {
        const moreStickerTool = canv.toolBox.TryGetToolByName(
            "moreStickerTool",
        ) as MoreStickersTool;
        moreStickerTool.setUrl(path);

        canv.toolBox.switchTo(moreStickerTool);
        canv.redraw();
    }, []);

    const stickersClassName = cx(style.stickersWindowContent, "scrollable");

    if (searchQuery && !stickers.length) {
        return <div className={style.emptyText}>Ничего не найдено</div>;
    }

    return (
        <>
            {searchQuery && !!stickers.length && (
                <div className={style.searchResultText}>Результаты поиска</div>
            )}
            <div className={stickersClassName}>
                {stickers.map((sticker) => {
                    const path = sticker.imageUrl || stickerCache.getImageUrl(sticker.name);

                    return (
                        <div
                            onMouseDown={() => itemClick(path)}
                            className={style.stickersWindowContentItem}
                            key={sticker.name}
                        >
                            <img src={path} aria-label="Стикер" alt={sticker.name} />
                        </div>
                    );
                })}
            </div>
        </>
    );
});
